const SESSION_FLAG_KEY = "ecotrack_session_active";

export const getStoredToken = () => {
  try {
    return (
      window?.localStorage?.getItem("token") ||
      window?.sessionStorage?.getItem("token") ||
      null
    );
  } catch {
    return null;
  }
};

export const setStoredToken = (token) => {
  try {
    window?.localStorage?.setItem("token", token);
  } catch {
    // ignore storage errors
  }
  try {
    window?.sessionStorage?.setItem("token", token);
    window?.sessionStorage?.setItem(SESSION_FLAG_KEY, "true");
  } catch {
    // ignore storage errors
  }
};

export const getStoredUser = () => {
  try {
    const raw =
      window?.localStorage?.getItem("user") ||
      window?.sessionStorage?.getItem("user") ||
      "null";
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setStoredUser = (user) => {
  const payload = JSON.stringify(user);
  try {
    window?.localStorage?.setItem("user", payload);
  } catch {
    // ignore storage errors
  }
  try {
    window?.sessionStorage?.setItem("user", payload);
  } catch {
    // ignore storage errors
  }
};

export const clearStoredAuth = () => {
  try {
    window?.localStorage?.removeItem("token");
    window?.localStorage?.removeItem("user");
  } catch {
    // ignore storage errors
  }
  try {
    window?.sessionStorage?.removeItem("token");
    window?.sessionStorage?.removeItem("user");
    window?.sessionStorage?.removeItem(SESSION_FLAG_KEY);
  } catch {
    // ignore storage errors
  }
};

export const hasActiveSession = () => {
  let hasSessionFlag = false;
  try {
    hasSessionFlag = window?.sessionStorage?.getItem(SESSION_FLAG_KEY) === "true";
  } catch {
    hasSessionFlag = false;
  }

  // Force a fresh in-session login; old localStorage-only auth cannot bypass guards.
  if (!hasSessionFlag) return false;

  const token = getStoredToken();
  const user = getStoredUser();
  if (!token || !user || !(user.email || user.username)) {
    return false;
  }

  try {
    const tokenParts = String(token).split(".");
    if (tokenParts.length !== 3) return false;

    const base64 = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));

    if (payload?.exp && Date.now() >= Number(payload.exp) * 1000) {
      clearStoredAuth();
      return false;
    }

    return true;
  } catch {
    return false;
  }
};
